<template>
  <section class="btn_main_wrap">
    <p class="btn-title">
      {{ title }} **
      <a v-if="lightBoxCopy.title" class="info-button_popin" @click="togglePopin">
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
      </a>
    </p>
    <ul class="btn-quantity btn_wrap" data-tracking-id="specification-speed">
      <li @click="updateQty(false)" data-tracking-label="less">
        <a class="btn">
          <ul>
            <li></li>
          </ul>
        </a>
      </li>
      <li>
        <a class="btn" v-if="quantity >= 0">
          {{ scale[currentIndex].title}}
          <span>&nbsp;{{SoM}}</span>
        </a>
      </li>
      <li @click="updateQty(true)" data-tracking-label="more">
        <a class="btn">
          <ul>
            <li></li>
            <li></li>
          </ul>
        </a>
      </li>
    </ul>
    <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    active: [String, Number],
    SoM: String,
    title: String,
    lightBoxBtn: Boolean,
    lightBoxCopy: Object,
    range: Object,
    scale: Array,
    step: [String, Number]
  },
  data() {
    return {
      quantity: Number(this.active),
      currentIndex: 0,
      lightboxVisible: false
    };
  },
  components: {
    Lightbox
  },
  watch: {
    active: function(val) {
      this.quantity = Number(val);
      this.getCurrentIndex();
    }
  },
  mounted() {
    // update mounted value
    this.quantity = this.active;
    this.getCurrentIndex();
  },
  methods: {
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },
    async updateQty(bool) {
      try {
        // Calculate the new quantity
        const newItemQuantity = await this.calculateQty(bool);
        // emit the result to the parent
        if (newItemQuantity !== null) {
          return this.$emit(
            "event_parent",
            Number(this.scale[this.currentIndex].data)
          );
        }
      } catch (e) {
        console.log(e.message);
      }
    },
    calculateQty(bool) {
      if (bool) {
        // is current position isn't the last one
        // do Array Position + 1
        // if not do nothing
        const increase = this.currentIndex + Number(this.step);
        return increase <= this.scale.length - 1
          ? Number((this.currentIndex = increase))
          : this.currentIndex;
        // add one more item then emit it to parent
      }
      const decrease = this.currentIndex - Number(this.step);
      console.log(decrease);
      return decrease >= 0
        ? Number((this.currentIndex = decrease))
        : this.currentIndex;
    },
    getCurrentIndex() {
      // console.log(this.quantity);
      // get current position in the array
      return (this.currentIndex = this.scale.indexOf(
        this.scale.find(x => Number(x.data) === this.quantity)
      ));
    }
  }
};
</script>
